<div class="container pb-4 pt-4 ">
  <app-breadcrumb currentRouteName="Gestion des utilisateurs"></app-breadcrumb>
  <h1 class="pt-4">Gestion des utilisateurs</h1>
  <button class="btn btn-primary mt-2 mb-3" routerLink="nouveau">
    <fa-icon icon="plus-circle"></fa-icon>
    Demander l'ajout d'un utilisateur
  </button>
  <div>
    <a routerLink="historique">Consulter l'historique de mes demandes d'ajout</a>
  </div>

  <h2 class="pt-4">Liste des utilisateurs
    <a role="button" (click)="updateSort('lastname')"
      aria-label="Trier par Nom"
      class="cursor-pointer d-inline d-md-none float-end">
      @if (sortfield === 'lastname') {
        <fa-icon size="lg" icon="sort-alpha-down-alt"
        [icon]="sortreverse ? 'sort-alpha-down' : 'sort-alpha-down-alt'"></fa-icon>
      }
    </a>
  </h2>

  @if(contacts) {
    @let contactStarted = contacts | afftectedToStartedContract;
    @if(contactStarted.length > 0 ) {
      <ls-dynamic-table
        [data]="contactStarted"
        track="crmId"
        [(currentSort)]="sortfield"
        [(sortAsc)]="sortreverse"
        [rowCustomClass]="rowCustomClass()"
        [rowTooltip]="rowTooltip()"
        [headers]="tableHeaders"
        [actions]="tableActions">
        <ng-template let-item>
          <th scope="row" class="d-inline d-md-none pt-0">
            {{ item.firstname }} {{ item.lastname }}
            @if(item.referent) {
              <span class="d-block d-md-none text-success">
                Référent·e
              </span>
            }
          </th>
          <td class="d-none d-md-table-cell action">
            <div class="d-flex justify-content-center align-items-center h-100">
              @let underModification = isUserUnderModification(item);
              @if(item.enabled && !underModification) {
                <fa-icon icon="check" class="text-success"/>
              } @else if(underModification) {
                <fa-icon icon="lock" class="text-info"/>
              } @else {
                <fa-icon icon="times" class="text-warning"/>
              }
            </div>
          </td>
          <td class="d-none d-md-table-cell">
            {{ item.lastname }}
          </td>
          <td class="d-none d-md-table-cell">
            {{ item.firstname }}
          </td>
          <td>
            {{ item.email }}
          </td>
          <td class="d-none d-md-table-cell">
            @if(item.referent) {
              Référent Portail
            } @else {
              Simple
            }
          </td>

          <td class="pb-2 pb-md-0">
            @for(contract of item.contracts; track contract) {
              @if(!contract.status.toLowerCase().startsWith('Not Started'.toLowerCase())) {
                @let cat = getCategoryFromProduct(contract.product);
                @if(cat !== undefined) {
                  <span class="d-inline mt-1 mb-1" style="zoom: 0.8">
                    <app-badge class="me-2 me-md-1 ms-md-1 ms-0"
                    [label]="{id: 0, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"></app-badge>
                  </span>
                }
              }
            }
          </td>
        </ng-template>
      </ls-dynamic-table>
    } @else {
      <div>
        <p class="text-light-grey">Aucun utilisateur sur vos contrats actifs</p>
      </div>
    }
  } @else {
    <ls-spinner/>
  }
</div>

<app-dynamic-modal-form size="lg"
  [title]="getModalTitleFromAction()"
  [object]="actionContact"
  [actions]="modalActions"
  (onSubmit)="handleConfirmAction()"
  (onCancel)="actionContact = undefined">
  <ng-template let-object="object">
    @if(actionAsked != ActionAsked.enable) {
      <div>
        <div class="form-check pt-2 pb-2">
          <input class="form-check-input" type="radio" name="action" id="action1" value="leaving"
            [(ngModel)]="actionType">
          <label class="form-check-label" for="action1">
            Je souhaite supprimer ce compte définitivement suite à un départ de la collectivité
          </label>
        </div>
        <div class="form-check pt-2 pb-2">
          <input class="form-check-input" type="radio" name="action" id="action2" value="delete"
            [(ngModel)]="actionType">
          <label class="form-check-label" for="action2">
            Je souhaite supprimer ce compte du Portail client
          </label>
        </div>
        @if(object.enabled) {
          <div class="form-check pt-2 pb-2">
            <input class="form-check-input" type="radio" name="action" id="action3" value="suspend"
              [(ngModel)]="actionType">
            <label class="form-check-label" for="action3">
              Je souhaite suspendre de façon temporaire ce compte
            </label>
          </div>
        } @else if (actionAsked != ActionAsked.remove) {
          <div class="form-check pt-2 pb-2">
            <input class="form-check-input" type="radio" name="action" id="action4" value="enable"
              [(ngModel)]="actionType">
            <label class="form-check-label" for="action4">
              Je souhaite ré-activer ce compte
            </label>
          </div>
        }
      </div>
    }

    @switch (actionType) {
      @case ('delete') {
        <div class="pt-3">
          <div class="alert alert-danger grid-gap-05rem d-flex align-items-center">
            <fa-icon icon="exclamation-triangle" size="lg"></fa-icon>
            <p class="mb-0">La suppression définitive implique la suppression du compte utilisateur de la base de données
            du Portail client.</p>
          </div>

          <p class="fw-bold">Êtes-vous sûr de vouloir supprimer définitivement le compte
          de {{ object.firstname }} {{ object.lastname }} ?</p>
        </div>
      }
      @case ('leaving') {
        <div class="pt-3">
          <div class="alert alert-danger grid-gap-05rem d-flex align-items-center">
            <fa-icon icon="exclamation-triangle" size="lg"></fa-icon>
            <p class="mb-0">La suppression définitive implique la suppression du compte utilisateur de la base de données
            Libriciel SCOP.</p>
          </div>

          <p class="fw-bold">Êtes-vous sûr de vouloir supprimer définitivement le compte
          de {{ object.firstname }} {{ object.lastname }} ?</p>
        </div>
      }
      @case ('suspend') {
        <div class="pt-3">
          <div class="alert alert-warning grid-gap-05rem d-flex align-items-center">
            <fa-icon icon="exclamation-triangle" size="lg"></fa-icon>
            <p class="mb-0">La suspension temporaire implique la désactivation du compte utilisateur de la base de données
              Libriciel SCOP. <br><span class="fw-bold">Ce compte pourra être réactivé.</span></p>
            </div>
            <p class="fw-bold">Êtes-vous sûr de vouloir suspendre temporairement le compte
            de {{ object.firstname }} {{ object.lastname }} ?</p>
          </div>
        }
        @case ('enable') {
          <div class="pt-3">
            <div class="alert alert-info grid-gap-05rem d-flex align-items-center">
              <fa-icon icon="info-circle" size="lg"></fa-icon>
              <p class="mb-0">La demande de réactivation sera traitée dans les meilleurs délais. Un mail sera envoyé à
              l'utilisateur l'informant de la réactivation de son compte.</p>
            </div>
            <p class="fw-bold">Êtes-vous sûr de vouloir réactiver le compte
            de {{ object.firstname }} {{ object.lastname }} ?</p>
          </div>
        }
      }
    </ng-template>
  </app-dynamic-modal-form>
